import { render, staticRenderFns } from "./FourhComp.vue?vue&type=template&id=0fc30db1&scoped=true&"
import script from "./FourhComp.vue?vue&type=script&lang=js&"
export * from "./FourhComp.vue?vue&type=script&lang=js&"
import style0 from "./FourhComp.vue?vue&type=style&index=0&id=0fc30db1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc30db1",
  null
  
)

export default component.exports